import { Radio } from '@televet/kibble-ui/build/components/Radio';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import React from 'react';
import RecipientCount from './RecipientCount';
import { Card } from '@televet/kibble-ui/build/components/Card';

export type SegmentProps = {
  title: string;
  recipientCount?: number | null;
  displayCount?: boolean;
  description: string | JSX.Element;
  isSelected?: boolean;
  onSelect: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  children?: JSX.Element;
  disabled?: boolean;
  loadingCount?: boolean;
};

const Segment = ({
  title,
  recipientCount,
  displayCount,
  description,
  isSelected,
  onSelect,
  children,
  loadingCount,
  disabled,
}: SegmentProps): JSX.Element => {
  return (
    <Card
      onClick={(): void => {
        onSelect();
      }}
      flexDirection="column"
      borderWidth={1}
      borderRadius="lg"
      mr="3"
      p="3"
      mt="3"
      isInteractive={true}
      isActive={!!isSelected}
      opacity={disabled ? 0.6 : 1}
    >
      <Flex gap="3" width="100%" flex={1}>
        <Radio size="lg" isChecked={isSelected} onChange={onSelect} isDisabled={disabled} />
        <Box width="100%">
          <Text as="p" fontWeight="bold" mb="1">
            {title}{' '}
            {displayCount && (
              <Text fontWeight="normal">
                <RecipientCount recipientCount={recipientCount} loading={loadingCount} />
              </Text>
            )}
          </Text>
          <Text fontWeight="normal" color="text.subtle">
            {description}
          </Text>
          {children}
        </Box>
      </Flex>
    </Card>
  );
};

export default Segment;
